import EquipmentSupplyRequestTicketDetail from './EquipmentSupplyRequestTicketDetail';

export default EquipmentSupplyRequestTicketDetail;
